import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { UsersTab } from '../components/UsersTab';
import { GroupsTab } from '../components/GroupsTab';
import { UserLoggingTab } from '../components/UserLoggingTab';
import { Badge } from '../../../components/ui/badge';
import { ShieldCheckIcon, UsersIcon } from '@heroicons/react/24/outline';
import { Activity } from 'lucide-react';

/**
 * User Management Component
 * Manages firm users, groups, roles, access controls, and logging
 */
const UserManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center">
            <ShieldCheckIcon className="h-8 w-8 mr-3 text-lex-accent" />
            User Management
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Manage firm users, groups, roles, access controls, and activity monitoring
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Badge variant="secondary">
            <UsersIcon className="h-4 w-4 mr-1" />
            Admin Only
          </Badge>
        </div>
      </div>

      {/* Main Content */}
      <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <div className="border-b border-gray-200 dark:border-gray-700 px-6">
            <TabsList className="grid w-full grid-cols-3 bg-gray-100 dark:bg-gray-700">
              <TabsTrigger 
                value="users" 
                className="data-[state=active]:bg-white dark:data-[state=active]:bg-gray-800"
              >
                <UsersIcon className="h-4 w-4 mr-2" />
                Users
              </TabsTrigger>
              <TabsTrigger 
                value="groups" 
                className="data-[state=active]:bg-white dark:data-[state=active]:bg-gray-800"
              >
                <ShieldCheckIcon className="h-4 w-4 mr-2" />
                Groups
              </TabsTrigger>
              <TabsTrigger 
                value="logging" 
                className="data-[state=active]:bg-white dark:data-[state=active]:bg-gray-800"
              >
                <Activity className="h-4 w-4 mr-2" />
                User Logging
              </TabsTrigger>
            </TabsList>
          </div>
          
          <TabsContent value="users" className="p-6">
            <UsersTab />
          </TabsContent>
          
          <TabsContent value="groups" className="p-6">
            <GroupsTab />
          </TabsContent>
          
          <TabsContent value="logging" className="p-0">
            <UserLoggingTab />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default UserManagement;
